'use client';
import { useState } from 'react';
import { FormPopup } from '@/components/FormPopup';
import useThemeStore from '@/app/stores/useThemeStore';
import ToastMessage from '@/components/ToastMessage';
import { useGlobalStore } from '@/app/stores/useGlobalStore';

function BookConsultationNow() {
  const { setCtaLabel, setHasShownPopup } = useGlobalStore();
  const { showToast } = useThemeStore((state) => state);
  const [showFormPopup, setShowFormPopup] = useState(false);

  const platform = process.env.NEXT_PUBLIC_PLATFORM;
  const isKaretripBlog = platform === 'karetrip-blog';

  const handleClick = () => {
    if (isKaretripBlog) {
      const whatsappUrl = `https://wa.me/${process.env.NEXT_PUBLIC_WHATSAPP_AI_AGENT_NUMBER}?text=Hi, I have a question about treatment. Can you help me with my query?`;
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    } else {
      setShowFormPopup(true);
      setCtaLabel('Hero Section Navbar cta');
      setHasShownPopup(true);
    }
  };

  return (
    <div className='min-w-[220px]'>
      {showToast && <ToastMessage />}
      <FormPopup openPopup={showFormPopup} setOpenPopup={setShowFormPopup} />
      <button
        className='h-[40px] w-[200px] rounded-[8px] border border-[#00b4b9] bg-[#00b4b9] p-[10px_0px] text-center text-[13px]
      font-normal tracking-[-.036px] text-[#fff] transition-all duration-500 ease-in-out
      hover:bg-white hover:tracking-[-.50px] hover:text-[#1c2534] '
        onClick={handleClick}
      >
        {isKaretripBlog ? 'Chat With Rua' : 'Get a Callback'}
      </button>
    </div>
  );
}

export default BookConsultationNow;
